export default __webpack_public_path__ + "static/media/rocket.4d90be59.svg";